import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=7f9a75ba&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"
import style0 from "./DashBoard.vue?vue&type=style&index=0&id=7f9a75ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a75ba",
  null
  
)

export default component.exports